import { createRoot } from "react-dom/client";
import "bootstrap/dist/css/bootstrap.min.css";
import App from "./App";

import reportWebVitals from "./appConfigs/reportWebVitals";
import "./appConfigs/index.css";

const container = document.getElementById("root");

if (container !== null) {
  const root = createRoot(container);
  root.render(<App />);
}

reportWebVitals();
